module.exports = __webpack_public_path__ + "static/media/banana-is-wrong.139c43a4.mp3";